// import 'regenerator-runtime/runtime'
// import './order.pug'
import './order.scss';

import '../../components/useful/useful.component';
import '../../components/partners/partners.component';
import '../../components/reviews/reviews.component';
import '../../components/subscribe/subscribe.component';
import {Application} from "@/helpers/app";

Application.run();
